// @flow
import { PRIMARY_COLOR, RED_COLOR } from 'coooltv-js-shared/src/styles/common';
import * as React from 'react';
import {
    StyleSheet, View, Text, ActivityIndicator, useWindowDimensions,
} from 'react-native';
import { defineMessages, FormattedMessage } from 'react-intl';
import { APIContext } from 'speed-js-react';
import MainWrapper from 'src/components/MainWrapper';
import StyledButton from 'src/components/StyledButton/StyledButton';
import Title from 'src/components/Title';
import { HOME_SCREEN, TRIAL_PERIOD_QUEUE } from 'src/navigation/constants';
import { GREY_COLOR } from 'src/styles/common';

const styles = StyleSheet.create({
    // headerIconContainer: {
    //     flexDirection: 'row',
    //     justifyContent: 'center',
    // },
    // headerTitleContainer: {
    //     paddingTop: 35,
    //     paddingLeft: 35,
    //     flexDirection: 'row',
    // },
    // headerTitleGrayText: {
    //     fontFamily: 'Open Sans',
    //     color: GREY_COLOR,
    //     fontSize: 50,
    //     fontWeight: 500,
    // },
    // headerTitleGreenText: {
    //     fontFamily: 'Open Sans',
    //     color: PRIMARY_COLOR,
    //     fontSize: 50,
    //     fontWeight: 500,
    // },
    // pageTitle: {
    //     fontFamily: 'Open Sans',
    //     fontSize: 33,
    //     textAlign: 'center',
    //     marginTop: 20,
    //     color: PRIMARY_COLOR,
    //     fontWeight: 550,
    // },
    // separatorLine: {
    //     height: 2,
    //     backgroundColor: PRIMARY_COLOR,
    //     marginTop: 30,
    //     marginBottom: 50,
    // },
    title: {
        fontFamily: 'Open Sans',
        fontSize: 24,
        color: GREY_COLOR,
        fontWeight: 300,
        paddingHorizontal: 150,
    },
    titlePhone: {
        fontFamily: 'Open Sans',
        fontSize: 20,
        color: GREY_COLOR,
        fontWeight: 300,
        paddingHorizontal: 20,
    },
    titleSmall: {
        fontFamily: 'Open Sans',
        fontSize: 18,
        color: GREY_COLOR,
        fontWeight: 300,
        textAlign: 'center',
        paddingHorizontal: 150,
    },
    titleSmallPhone: {
        fontFamily: 'Open Sans',
        fontSize: 16,
        color: GREY_COLOR,
        fontWeight: 300,
        textAlign: 'center',
        paddingHorizontal: 20,
    },
    myCbContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 70,
    },
    trialContainer: {
        marginTop: 100,
        flexDirection: 'column',
        alignItems: 'center',
    },
    buttonView: {
        width: 500,
    },
    buttonViewPhone: {
        width: '90%',
    },
    spinner: {
        marginTop: 30,
    },
    expiredInvitation: {
        fontFamily: 'Open Sans',
        fontSize: 24,
        color: RED_COLOR,
        fontWeight: 300,
        marginBottom: 30,
        textAlign: 'center',
    },
    borderTopView: {
        borderTopWidth: 1,
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        marginTop: -2,
        marginBottom: 50,
    },
});

const messages = defineMessages({
    trialInvitationMessage: {
        id: 'trial-invitation-message',
        defaultMessage: 'Your trial period request can be accomplished! In the next {hours} hours you'
            + 'can activate your free 3-day trial.',
    },
});

let prefix = `${process.env.PUBLIC_URL}/`.replace('//', '/');
if (prefix.startsWith('/')) {
    prefix = prefix.substr(1);
}

const StartTrialPeriod = (): React.Node => {
    const { apiClient } = React.useContext(APIContext);
    const { width } = useWindowDimensions();
    const [loadingEligibility, setLoadingEligibility] = React.useState(false);
    const [loadingTrialCreation, setLoadingCreation] = React.useState(false);
    const [trialEligibility, setTrialEligibility] = React.useState(null);
    const [invitationExpirationDate, setInvitationExpirationDate] = React.useState(null);

    React.useEffect(() => {
        setLoadingEligibility(true);
        apiClient.resources.currentAccounts.checkTrialEligibility()
            .then((response) => {
                setTrialEligibility(response.data.result);
                setInvitationExpirationDate(response.data.invitation_expiration_date);
                setLoadingEligibility(false);
            });
    }, [apiClient.resources.currentAccounts]);

    React.useEffect(() => {
        if (trialEligibility === 'active_accounts') {
            // Already have active accouns, redirect to home page
            window.location = `/${prefix}${HOME_SCREEN}`;
        }
    }, [trialEligibility]);

    const startTrial = React.useCallback(() => {
        setLoadingCreation(true);
        apiClient.resources.currentAccounts.startTrial()
            .then((response) => {
                if (response.data?.result === 'must_queue') {
                    // Trial creation failed, user should be queued
                    window.location = `/${prefix}${TRIAL_PERIOD_QUEUE}`;
                } else {
                    // Successful trial activation, redirect to home page
                    window.location = `/${prefix}${HOME_SCREEN}`;
                }
            });
    }, [apiClient.resources.currentAccounts]);

    const acceptTrialInvitation = React.useCallback(() => {
        setLoadingCreation(true);
        apiClient.resources.currentAccounts.acceptTrialInvitation()
            .then(() => {
                window.location = `/${prefix}${HOME_SCREEN}`;
            });
    }, [apiClient.resources.currentAccounts]);

    const getInvitationExpirationHours = React.useCallback(() => {
        if (invitationExpirationDate) {
            const dateNow = new Date();
            const invitationExpirationDateObj = new Date(invitationExpirationDate);
            return Math.ceil(Math.abs(dateNow - invitationExpirationDateObj) / 36e5);
        }
        return 'XX';
    }, [invitationExpirationDate]);

    return (
        <View>
            <MainWrapper>
                {/* <View style={styles.headerIconContainer}> */}
                {/*    <ServiceIcon /> */}
                {/*    <View style={styles.headerTitleContainer}> */}
                {/*        <Text style={styles.headerTitleGrayText}> */}
                {/*            coool */}
                {/*        </Text> */}
                {/*        <Text style={styles.headerTitleGreenText}> */}
                {/*            TV */}
                {/*        </Text> */}
                {/*    </View> */}
                {/* </View> */}
                {/* <Text style={styles.pageTitle}> */}
                {/*    <FormattedMessage */}
                {/*        id="activate-your-trial-period" */}
                {/*        defaultMessage="Activate your trial period" */}
                {/*    /> */}
                {/* </Text> */}
                {/* <View style={styles.separatorLine} /> */}
                {trialEligibility === 'expired_trial' && (
                    <Text style={styles.expiredInvitation}>
                        <FormattedMessage
                            id="expired-trial-period"
                            defaultMessage="Your 3-day trial period has ended. Activation of a regular subscription can
                            be done at any time, through My Cooolbox."
                        />
                    </Text>
                )}
                {trialEligibility === 'expired_invitation' && (
                    <Text style={styles.expiredInvitation}>
                        <FormattedMessage
                            id="expired-trial-period-invitation"
                            defaultMessage="Your trial period invitation expired!"
                        />
                    </Text>
                )}
                <Title text={(
                    <FormattedMessage
                        id="activate-your-trial-period"
                        defaultMessage="Activate your trial period"
                    />
                )}
                />
                <View style={styles.borderTopView}>
                    {!loadingEligibility ? (
                        <>
                            <View style={styles.myCbContainer}>
                                <Text style={width > 600 ? styles.title : styles.titlePhone}>
                                    <FormattedMessage
                                        id="activate-through-mycb-message"
                                        defaultMessage="The activation of coool.tv can be accomplished through the
                                        client portal MyCooolbox, without visit, any time of the day."
                                    />
                                </Text>
                                <View style={width > 600 ? styles.buttonView : styles.buttonViewPhone}>
                                    <StyledButton
                                        handleSubmit={() => { window.location = 'https://my.cooolbox.bg/'; }}
                                        text={
                                            <FormattedMessage id="my-cooolbox" defaultMessage="My Cooolbox" />
                                        }
                                    />
                                </View>
                            </View>
                            {(trialEligibility === 'eligible' || trialEligibility === 'expired_invitation') && (
                                <View style={styles.trialContainer}>
                                    <Text style={width > 600 ? styles.title : styles.titlePhone}>
                                        <FormattedMessage
                                            id="enroll-in-the-trial-message"
                                            defaultMessage="You want to try coool.tv before signing up? Every client
                                            with a home service can activate a free 3-day trial period."
                                        />
                                    </Text>
                                    {!loadingTrialCreation ? (
                                        <View style={width > 600 ? styles.buttonView : styles.buttonViewPhone}>
                                            <StyledButton
                                                handleSubmit={startTrial}
                                                text={(
                                                    <FormattedMessage
                                                        id="activate-trial-period"
                                                        defaultMessage="Activate trial period"
                                                    />
                                                )}
                                            />
                                        </View>
                                    ) : (
                                        <ActivityIndicator
                                            size="large"
                                            color={PRIMARY_COLOR}
                                            style={styles.spinner}
                                        />
                                    )}
                                </View>
                            )}
                            {trialEligibility === 'already_trial_queue' && (
                                <View style={styles.trialContainer}>
                                    <Text style={width > 600 ? styles.titleSmall : styles.titleSmallPhone}>
                                        <FormattedMessage
                                            id="already-in-trial-queue-message"
                                            defaultMessage="You have successfully signed up for a trial period and are
                                            in the queue. When a free spot is available, you will receive
                                            an invitation on your email."
                                        />
                                    </Text>
                                </View>
                            )}
                            {trialEligibility === 'active_invitation' && (
                                <View style={styles.trialContainer}>
                                    <Text style={width > 600 ? styles.title : styles.titlePhone}>
                                        <FormattedMessage
                                            {...messages.trialInvitationMessage}
                                            values={{ hours: getInvitationExpirationHours() }}
                                        />
                                    </Text>
                                    {!loadingTrialCreation ? (
                                        <View style={width > 600 ? styles.buttonView : styles.buttonViewPhone}>
                                            <StyledButton
                                                handleSubmit={acceptTrialInvitation}
                                                text={(
                                                    <FormattedMessage
                                                        id="activate-trial-period"
                                                        defaultMessage="Activate trial period"
                                                    />
                                                )}
                                            />
                                        </View>
                                    ) : (
                                        <ActivityIndicator
                                            size="large"
                                            color={PRIMARY_COLOR}
                                            style={styles.spinner}
                                        />
                                    )}
                                </View>
                            )}
                        </>
                    ) : (
                        <ActivityIndicator
                            size="large"
                            color={PRIMARY_COLOR}
                            style={styles.spinner}
                        />
                    )}
                </View>
            </MainWrapper>
        </View>
    );
};
export default StartTrialPeriod;
